export function formatCurrency(value, currency = 'USD') {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

/** Whole-dollar display for catalog cards, product pages, and similar browse UI. */
export function formatCurrencyDisplay(value, currency = 'USD') {
  const n = Number(value || 0);
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `$${Math.round(n).toLocaleString()}`;
  }
}

export function round2(n) {
  return Math.round(Number(n || 0) * 100) / 100;
}

